import React from "react";

import { FormControlLabel, Radio } from "@material-ui/core";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import { EditorMode, IEditorState, setMode } from "../..";

interface IModeProps {
    mode: EditorMode;
    style?: React.CSSProperties;

    getModeTransform: (mode: EditorMode) => () => void;
}

const ModeWidget = (props: IModeProps) => (
    <div style={props.style}>
        <FormControlLabel
            value="edit"
            control={
                <Radio
                    checked={props.mode === EditorMode.Edit}
                    onChange={props.getModeTransform(EditorMode.Edit)}
                    color="secondary"
                    radioGroup="viewGroup"
                />
            }
            label="Edit"
            labelPlacement="start"
        />
        <FormControlLabel
            value="preview"
            control={
                <Radio
                    checked={props.mode === EditorMode.Preview}
                    onChange={props.getModeTransform(EditorMode.Preview)}
                    radioGroup="viewGroup"
                />
            }
            label="Preview"
            labelPlacement="start"
        />
    </div>
)

const stateToProps = (state: IEditorState) => ({ 
    mode: state.mode
})

const dispatchToProps = (dispatch) => ({
    getModeTransform: (mode: EditorMode) => () => dispatch(setMode(mode)),
})

export const EditorModeWidget = connect(stateToProps, dispatchToProps)(ModeWidget);